<!--
@Author: Calvin Green <calvin>
@Date:   2022-04-07T20:34:49+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T09:16:43+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <div v-show="suppliers.length == 0">
            <div style="text-align: center; font-size: 25px;">
                <span>Please add a supplier!</span>
            </div>
        </div>
        <div v-show="suppliers.length > 0">
            <webix-ui :config="config" v-model="suppliers"></webix-ui>
            <div id="suppliersPaging"></div>
        </div>
    </div>
</template>

<script>
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import Swal from "sweetalert2";
export default {
    data:() => ({
        clickedAction: false,
        config:{
            id: 'suppliersTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            autoheight: true,
            //hover: "datatableHover",
            minHeight:50,
            minColumnWidth: 120,
            scrollY:false,
            scrollX:true,
            resizeColumn: true,
            select: false,
            pager:{
                template:"{common.prev()} {common.pages()} {common.next()}",
                container:"suppliersPaging",
                size:15,
                group:5
            },
            columns:[
                { id: 'actions', header:'Actions', fillspace: 0.2,  template: function(){
                    return '<div class="tableIcons"><i title="View Supplier" class="viewAction iconHover fas fa-binoculars"></i>&nbsp;<i title="Delete Supplier" class="deleteAction  iconHover webix_icon_hover webix_icon delete_icon fas fa-trash"></i></div>'
                }},
                { id: 'company_name', header:["Company Name", {content: "textFilter"}], tooltip:false, fillspace: 1},
                { id: 'company_address',  header:["Address", {content: "textFilter"}], fillspace: 1},
                { id: 'tel_no', header:["Contact Number", {content: "textFilter"}], fillspace: 1},
                { id: 'company_email', header:["Company Email", {content: "textFilter"}], fillspace: 1.2},
                { id: 'contact_person', header:["Contact Person", {content: "textFilter"}], fillspace: 1},
                { id: 'supplier_type', header:["Supplier Type", {content: "selectFilter"}], fillspace: 0.6},
                { id: 'activity_description', header:'Supplier Activity Description', fillspace: 1},
            ],
            on:{

            },
            onClick:{//eslint-disable-next-line
                viewAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    el.$emit('editSupplier', e.row);
                },//eslint-disable-next-line
                deleteAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    var item = this.getItem(e.row);
                    Swal.fire({
                      title: "Are you sure you want to delete " + item.company_name + "?",
                      text: "You won't be able to revert this!",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#34c38f",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Yes, delete it!"
                    }).then(result => {
                      if (result.value) {
                          el.deleteClientSupplier({supplier_id: e.row}).then(()=>{
                              el.loadClientSuppliers();
                          });
                      }
                  });
                }
            },
        },
    }),
    computed:{
        ...facilityAdminState,
        suppliers(){
            let data = [];
            if(this.client_suppliers != null){
                data = this.client_suppliers
            }
            return data;
        }
    },
    methods:{
        ...facilityAdminMethods,
    },
    mounted() {

    },
}
</script>

<style>
.tableIcons {
    cursor: pointer;
    font-size: 1.5rem;
    text-align: center;
}
.iconHover:hover{
    color: var(--bs-danger);
    cursor: pointer;
}
</style>
